import request from "../api/agent";

const API_ROUTE = "reports";

export class LockBoxFileMonitoringService {

  async getLockBoxFileMonitoringSummery({ page, limit, station, date_range, hour_count, clients, facilities, partners, deposit_date_range, build_date_range, output_generated_range, internal_tat_range, output_send_date_range, file_type, sort_key, sort_order, export_type, filename ,header_names}) {

    const params = `?page=${page}&limit=${limit}&date_range=${date_range}&facilities=${facilities}&clients=${clients}&partners=${partners}&deposit_date_range=${deposit_date_range}&build_date_range=${build_date_range}&output_generated_range=${output_generated_range}&internal_tat_range=${internal_tat_range}&output_send_date_range=${output_send_date_range}&file_type=${file_type}&sort_key=${sort_key}&sort_order=${sort_order}&export=${export_type}&header_names=${header_names}&filename=${encodeURIComponent(filename ||'')}`

    const response = await request.get(`${API_ROUTE}/house-keeping/retireve-files` + params);
    return response.data ?? response?.response?.data;

  }

  async downloadLockBoxFileMonitoringSummery(data) {
    const response = await request.post(`${API_ROUTE}/house-keeping/retireve-file-urls`, data);
    return response.data;
  }

  async getLockBoxFileMonitoringAuditLog(page, limit, station, job_status, date_range, hour_count, clients, facilities) {
    const params = `?page=${page}&limit=${limit}&date_range=${date_range}&job_status=${job_status}&facilities=${facilities}&clients=${clients}`

    const response = await request.get(`${API_ROUTE}/job-report-single-download` + params);
    return response.data;
  }

  async getFileAuditLogs({ page, limit, created_date_range, users, file_type }) {
    const params = `?page=${page}&limit=${limit}&created_date_range=${created_date_range ?? ''}&users=${users ?? ''}&file_type=${file_type ?? ''}`;
    const response = await request.get(`${API_ROUTE}/house-keeping/retireve-file-audit-logs` + params);
    return response.data ?? response?.response?.data;
  }

}